module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0115.png.b05b7c88.jpg";